export const EchoConfig = {
    broadcaster: 'pusher',
    key: 'cf2cc5f1daa5e884172b',
    cluster: 'mt1',
    forceTLS: true
}
